import { createApi } from '@reduxjs/toolkit/query/react'
import PrintJob from '../../types/api/print-job'
import Strapi, { StrapiSingle, StrapiUpdate } from '../../types/strapi/strapi'
import getCustomFetchBase from '../custom-fetch-base'
import { EndpointQueryParameters, StrapiCreate } from '../../types/strapi/strapi'
import getQuery from '../../helpers/api/get-query'
import { SubmitConsumptionResponse } from '../../types/api/print-job-consumption'
import { SubmitConsumptionBody } from '../../types/api/print-job-consumption'
import { shipmentsApi } from './shipments-api'
import { printQueueEntriesApi } from './print-queue-entries-api'
import {
    PrintJobPaints,
    SavePrintJobPaintsBody,
    SavePrintJobPaintsResponse,
} from '../../types/api/print-job-paints'

export const printJobsApi = createApi({
    reducerPath: 'printJobsApi',
    baseQuery: getCustomFetchBase({ baseUrl: import.meta.env.VITE_API_URL }),
    tagTypes: ['PrintJobs', 'Stocks', 'PrintJobPaints'],
    endpoints: builder => ({
        getPrintJobs: builder.query<Strapi<PrintJob>, EndpointQueryParameters | void>({
            query: getQuery('/print-jobs'),
            providesTags: ['PrintJobs'],
        }),
        createPrintJob: builder.mutation<StrapiSingle<PrintJob>, StrapiCreate<PrintJob>>({
            query: body => ({
                url: '/print-jobs',
                method: 'POST',
                body,
            }),
            invalidatesTags: ['PrintJobs'],
        }),
        updatePrintJob: builder.mutation<StrapiSingle<PrintJob>, StrapiUpdate<PrintJob>>({
            query: ({ docId, body }) => ({
                url: `/print-jobs/${docId}`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: ['PrintJobs'],
        }),
        submitConsumption: builder.mutation<SubmitConsumptionResponse, SubmitConsumptionBody>({
            query: body => ({
                url: '/print-jobs/consumption',
                method: 'POST',
                body,
            }),
            invalidatesTags: ['PrintJobs', 'Stocks'],
            async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
                try {
                    await queryFulfilled
                    dispatch(shipmentsApi.util.invalidateTags(['Shipments']))
                } catch {
                    // ошибка уже обрабатывается формой
                }
            },
        }),
        getPrintJobPaints: builder.query<PrintJobPaints, string>({
            query: docId => `/print-jobs/${docId}/paints`,
            providesTags: ['PrintJobPaints'],
        }),
        savePrintJobPaints: builder.mutation<
            SavePrintJobPaintsResponse,
            { docId: string; body: SavePrintJobPaintsBody }
        >({
            query: ({ docId, body }) => ({
                url: `/print-jobs/${docId}/paints`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: ['PrintJobPaints'],
            async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
                try {
                    await queryFulfilled
                    // статус подтверждения красок нужен кнопке «Завершить» в очереди станка
                    dispatch(printQueueEntriesApi.util.invalidateTags(['PrintQueueEntries']))
                } catch {
                    // ошибка обрабатывается модалкой
                }
            },
        }),
    }),
})

export const {
    useGetPrintJobsQuery,
    useCreatePrintJobMutation,
    useUpdatePrintJobMutation,
    useSubmitConsumptionMutation,
    useGetPrintJobPaintsQuery,
    useSavePrintJobPaintsMutation,
} = printJobsApi
